/**
 * The rail's action bar (unit convention §1). Every button is a leaf with its
 * own subscription; the bar's own model is which FACE to wear.
 *
 * Context-free (UX spec §6a): no navigation, no socket, no media query.
 */
import React from 'react';

import {useActionBarModel} from './model';
import ActionBarView from './View';

export default React.memo(function ActionBar() {
  return <ActionBarView {...useActionBarModel()} />;
});
